import { getAuthCode, myAppList } from "@root/graphql/Root.gql";
import { easyMutate, resRest } from "@root/lib/utils";

export default {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    async getAuthCode({ rootState, commit }: any, appCode) {
      let res = await rootState.gql.query({
        query: getAuthCode,
        variables: {
          appCode
        }
      });
      return res.data.getAuthCode.code;
    },

    // appList
    async getAppList({ rootState }, data) {
      let res = await rootState.gql.query({ query: myAppList });
      return res.data.queryMyAppList || [];
    }
  },
  mutations: {
    easyMutate
  }
};
